// Callback style wrapped fetch API for JSON request

import _ from 'lodash';
import fetch from 'isomorphic-fetch';

export function *entries(obj) {
  for (let key of Object.keys(obj)) {
    yield [key, obj[key]];
  }
}

let _btoa;
if (typeof btoa === 'undefined' && typeof Buffer === 'function') {
  _btoa = function (str) {
    return new Buffer(str).toString('base64');
  };
} else if (typeof btoa === 'function') {
  _btoa = btoa;
}

let defaultFetchOptions = {
  credentials: 'same-origin',
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
  },
};

function validateResponse(response) {
  if (!response.ok) {
    let error = new Error(response.statusText);
    error.response = response;
    error.statusCode = response.status;
    throw error;
  }
  return response;
}

function httpRequest(method, url, options = {}, requestCb) {
  if (!requestCb) {
    requestCb = options;
    options = {};
  }
  let xsrfToken;
  if (typeof document === 'object') {
    for (let cookieEntry of document.cookie.split(';')) {
      let [name, value] = cookieEntry.split('=');
      if (name.trim() === 'XSRF-TOKEN' && value.trim()) {
        xsrfToken = value.trim();
      }
    }
  }
  // Break out of the promise chain, not letting the promise catch any error not related to fetch itself
  let cb = function () {
    _.defer(_.spread(requestCb), arguments);
  };
  let fetchOptions = _.merge({}, defaultFetchOptions, options, {method});
  if (fetchOptions.auth) {
    if (fetchOptions.auth.user || fetchOptions.auth.pass) {
      let encoded = _btoa(`${fetchOptions.auth.user}:${fetchOptions.auth.pass}`);
      fetchOptions.headers.Authorization = `Basic ${encoded}`;
    }
  }
  if (xsrfToken) {
    fetchOptions.headers['X-XSRF-TOKEN'] = xsrfToken;
  }
  if (options.data || options.body) {
    fetchOptions.body = JSON.stringify(options.data || options.body);
  }
  let headers = {};
  if (typeof window === 'undefined' && url.indexOf(/https?:\/\//) !== 0 && fetchOptions.defaultOrigin) {
    url = `${fetchOptions.defaultOrigin}${url}`;
  }
  fetch(url, fetchOptions).then(validateResponse).then(response => {
    if (response.headers) {
      let headerEntries;
      if (response.headers && response.headers.entries) {
        headerEntries = response.headers.entries();
      } else if (response.headers && response.headers._headers) {
        headerEntries = entries(response.headers._headers);
      } else {
        headerEntries = [];
      }
      for (let [key, value] of headerEntries) {
        headers[key] = value;
      }
    }
    let meta = {};
    meta.statusCode = response.status;
    meta.headers = headers;
    if (response.status === 204) {
      return cb(null, null, meta, response);
    } else {
      response.text().then(text => {
        let result;
        try {
          result = JSON.parse(text);
        } catch (e) {
          result = text;
        }
        cb(null, result, meta, response);
      });
    }
  }).catch(err => {
    if (err.response) {
      err.response.json().then(json => {
        json.response = err.response;
        json.statusCode = err.statusCode;
        cb(json);
      }).catch(() => {
        cb(err);
      });
    } else {
      if (err.message === 'Failed to fetch') {
        err.message = 'There are issues with your Internet connection. Please try again later.';
      }
      cb(err);
    }
  });
}

export default {
  get: function (url, options, cb) {
    httpRequest('GET', url, options, cb);
  },
  post: function (url, options, cb) {
    httpRequest('POST', url, options, cb);
  },
  put: function (url, options, cb) {
    httpRequest('PUT', url, options, cb);
  },
  delete: function (url, options, cb) {
    httpRequest('DELETE', url, options, cb);
  },
  patch: function (url, options, cb) {
    httpRequest('PATCH', url, options, cb);
  },
  request: httpRequest,
  defaultOptions: function (options) {
    if (options) {
      defaultFetchOptions = _.merge({}, defaultFetchOptions, options);
    }
    return defaultFetchOptions;
  },
};



// WEBPACK FOOTER //
// ./~/sp-components/util/http.js